import { render, staticRenderFns } from "./LanguageSelector.vue?vue&type=template&id=54e1be22&scoped=true&"
import script from "./LanguageSelector.vue?vue&type=script&lang=js&"
export * from "./LanguageSelector.vue?vue&type=script&lang=js&"
import style0 from "@/styles/components/LanguageSelector/LanguageSelector.less?vue&type=style&index=0&id=54e1be22&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e1be22",
  null
  
)

export default component.exports